import { pxToRem } from '../../util';
export const getTooltipPosition = (position, targetDimensions, tooltipDimensions) => {
  const distanceFromTargetPx = 13;
  const distanceFromTargetRem = pxToRem(distanceFromTargetPx);
  switch (position) {
    case 'top':
      return `
        bottom: calc(100% + ${distanceFromTargetRem}rem);
        margin-left: -${pxToRem(tooltipDimensions.width / 2)}rem;
        transform: translate(${pxToRem(targetDimensions.width / 2)}rem);
      `;
    case 'top-start':
      return `
        bottom: calc(100% + ${distanceFromTargetRem}rem);
        transform: translate(${pxToRem(25 - tooltipDimensions.width)}rem);
      `;
    case 'top-end':
      return `
        bottom: calc(100% + ${distanceFromTargetRem}rem);
        transform: translate(${pxToRem(targetDimensions.width - 25)}rem);
      `;
    case 'bottom':
      return `
        top: calc(100% + ${distanceFromTargetRem}rem);
        margin-left: -${pxToRem(tooltipDimensions.width / 2)}rem;
        transform: translate(${pxToRem(targetDimensions.width / 2)}rem);
      `;
    case 'bottom-start':
      return `
        top: calc(100% + ${distanceFromTargetRem}rem);
        transform: translate(${pxToRem(25 - tooltipDimensions.width)}rem);
      `;
    case 'bottom-end':
      return `
        top: calc(100% + ${distanceFromTargetRem}rem);
        transform: translate(${pxToRem(targetDimensions.width - 25)}rem);
      `;
    case 'left':
      return `
        margin-top: -${pxToRem(tooltipDimensions.height / 2)}rem;
        transform: translate(-${pxToRem(tooltipDimensions.width + distanceFromTargetPx)}rem, ${pxToRem(targetDimensions.height / 2)}rem);
      `;
    case 'left-start':
      return `
        transform: translate(-${pxToRem(tooltipDimensions.width + distanceFromTargetPx)}rem, -${pxToRem(tooltipDimensions.height - 25)}rem);
      `;
    case 'left-end':
      return `
        transform: translate(-${pxToRem(tooltipDimensions.width + distanceFromTargetPx)}rem, ${pxToRem(targetDimensions.height - 25)}rem);
      `;
    case 'right':
      return `
        margin-top: -${pxToRem(tooltipDimensions.height / 2)}rem;
        transform: translate(${pxToRem(targetDimensions.width + distanceFromTargetPx)}rem, ${pxToRem(targetDimensions.height / 2)}rem);
      `;
    case 'right-start':
      return `
        transform: translate(${pxToRem(targetDimensions.width + distanceFromTargetPx)}rem, -${pxToRem(tooltipDimensions.height - 25)}rem);
      `;
    case 'right-end':
      return `
        transform: translate(${pxToRem(targetDimensions.width + distanceFromTargetPx)}rem, ${pxToRem(targetDimensions.height - 25)}rem);
      `;
    default:
      return getTooltipPosition('top', targetDimensions, tooltipDimensions);
  }
};
export const getTooltipClass = position => {
  switch (position) {
    case 'top':
      return 'tooltip--top';
    case 'bottom':
      return 'tooltip--bottom';
    case 'left':
      return 'tooltip--left';
    case 'right':
      return 'tooltip--right';
    case 'top-start':
      return 'tooltip--top-start';
    case 'top-end':
      return 'tooltip--top-end';
    case 'bottom-start':
      return 'tooltip--bottom-start';
    case 'bottom-end':
      return 'tooltip--bottom-end';
    case 'left-start':
      return 'tooltip--left-start';
    case 'left-end':
      return 'tooltip--left-end';
    case 'right-start':
      return 'tooltip--right-start';
    case 'right-end':
      return 'tooltip--right-end';
  }
};